/**
 * @file  PaddlePaddleFoundathon-2023-8-落地页
 * @author v_duzhengqiang
 */
import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import usePaddlePaddleFoundathonHook from './PaddlePaddleFoundathonHook';
import Banner from './components/banner/Banner';
import ExclusiveInterest from './components/exclusiveInterest/ExclusiveInterest';
import TrackIntroduction from './components/trackIntroduction/TrackIntroduction';
import TimeArrangement from './components/timeArrangement/TimeArrangement';
import EventAward from './components/eventAward/EventAward';
import ActivityRule from './components/activityRule/ActivityRule';
import ReviewDimension from './components/reviewDimension/ReviewDimension';
import LiveEvent from './components/liveEvent/LiveEvent';
import ExpertReview from './components/expertReview/ExpertReview';
import Partner from './components/partner/Partner';
import PublicityFixed from './components/publicityFixed/PublicityFixed';
import './style.less';

const PaddlePaddleFoundathon = () => {

    const {
        banner,
        exclusiveInterest,
        trackIntroduction,
        timeArrangement,
        eventAward,
        activityRule,
        reviewDimension,
        liveEvent,
        expertReview,
        partner,
        publicity
    } = usePaddlePaddleFoundathonHook();
    return (
        <div className="paddle-paddle-foundathon">
            <Header />
            <Banner {...banner} />
            <div className="paddle-paddle-foundathon-wrapper">
                <div className='background-foundathon-comman background-foundathon-1' />
                <div className='background-foundathon-comman background-foundathon-2' />
                <div className='background-foundathon-comman background-foundathon-3' />
                <div className='background-foundathon-comman background-foundathon-4' />
                <div className='background-foundathon-comman background-foundathon-5' />
                <div className='background-foundathon-comman background-foundathon-6' />
                {/* 专属权益 */}
                <ExclusiveInterest {...exclusiveInterest} />
                {/* 赛道介绍 */}
                <TrackIntroduction {...trackIntroduction} />
                {/* 时间安排 */}
                <TimeArrangement {...timeArrangement} />
                {/* 活动奖项 */}
                <EventAward {...eventAward} />
                {/* 活动规则 */}
                <ActivityRule {...activityRule} />
                {/* 评审维度 */}
                <ReviewDimension {...reviewDimension} />
                {/* 活动直播 */}
                <LiveEvent {...liveEvent} />
                {/* 专家评审 */}
                <ExpertReview {...expertReview} />
                {/* 合作伙伴 */}
                <Partner {...partner} />
                {/* 公示固定栏 */}
                <PublicityFixed {...publicity} />
            </div>

            <Footer />
        </div>
    );
};

export default PaddlePaddleFoundathon;
